import { render, staticRenderFns } from "./OrdemColetaFilterBar.vue?vue&type=template&id=6f583d89"
import script from "./OrdemColetaFilterBar.vue?vue&type=script&lang=js"
export * from "./OrdemColetaFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports